import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { api } from "@/lib/api";
import { SiteNav, SiteFooter } from "@/components/SiteChrome";

export default function Policy({ kind }) {
  const [content, setContent] = useState(null);
  useEffect(() => { setContent(null); api.get(`/public/policy/${kind}`).then((r) => setContent(r.data.content)).catch(() => setContent("")); }, [kind]);
  return (
    <div className="relative z-10 min-h-screen bg-background">
      <SiteNav />
      <article className="policy mx-auto max-w-3xl px-6 py-16" data-testid={`policy-${kind}`}>
        {content === null ? <p className="text-muted-foreground">Loading…</p> : <ReactMarkdown>{(content || "This policy is being updated.").replace(/^> \*\*Draft for review\.\*\*.*\n+/, "")}</ReactMarkdown>}
      </article>
      <SiteFooter />
    </div>
  );
}
